import React, { useMemo, useState, useEffect } from "react";
import RemindersContext from "./RemindersContext";

const STORAGE_KEY = "reminders";

const loadInitial = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

const RemindersProvider = ({ children }) => {
  const [reminders, setReminders] = useState(loadInitial);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(reminders));
    } catch (e) {
      // ignore
    }
  }, [reminders]);

  const addReminder = (reminder) => {
    const id = reminder.id || Date.now().toString();
    const next = { ...reminder, id };
    setReminders((prev) => [next, ...prev]);
    return next;
  };

  const deleteReminder = (id) => {
    setReminders((prev) => prev.filter((r) => r.id !== id));
  };

  const getRemindersForTask = (taskId) =>
    reminders.filter((r) => String(r.taskId) === String(taskId));

  const upcomingCount = reminders.length;

  const value = useMemo(
    () => ({ reminders, addReminder, deleteReminder, getRemindersForTask, upcomingCount }),
    [reminders]
  );

  return <RemindersContext.Provider value={value}>{children}</RemindersContext.Provider>;
};

export default RemindersProvider;
